export const Currency = 'Rs. ';